<template>
  <div class="min-h-screen max-w-full m-auto">
    <!-- Header -->
    <HeroHeader />

    <!-- Overlay (dim background) -->
    <div
      v-if="sidebarOpen"
      class="fixed inset-0 bg-black bg-opacity-50 z-40"
      @click="sidebarOpen = false"
    ></div>

    <!-- Sidebar -->
    <transition name="slide">
      <HeroMobileSidebar
        v-if="sidebarOpen"
        @toggle-sidebar="sidebarOpen = !sidebarOpen"
        class="fixed inset-y-0 left-0 w-full bg-white shadow-lg z-50"
      />
    </transition>

    <!-- Router Content -->
    <div class="mb-16">
      <router-view
        @checkIfhaveTrans="getEmitData"
        :isTransaction="isIniateTransaction"
      />
    </div>

    <!-- Bottom Mobile Nav -->
    <HeroMobileNav
      @toggle-sidebar="sidebarOpen = !sidebarOpen"
      class="fixed bottom-0 w-full z-30"
    />
  </div>
</template>

<script>
import HeroHeader from "@/components/common/portal/HeroHeader.vue";
import HeroMobileNav from "@/components/common/HeroMobileNav.vue";
import HeroMobileSidebar from "@/components/common/HeroSidebar.vue";
import { ref } from "vue";

export default {
  components: {
    HeroHeader,
    HeroMobileNav,
    HeroMobileSidebar,
  },
  setup() {
    const isCurrentTransaction = ref(false);
    const isIniateTransaction = ref(false);
    const sidebarOpen = ref(false);

    const getEmitData = (val) => {
      isCurrentTransaction.value = val;
    };

    const getEmitTransaction = (val) => {
      isIniateTransaction.value = val;
    };

    return {
      getEmitData,
      isCurrentTransaction,
      isIniateTransaction,
      getEmitTransaction,
      sidebarOpen,
    };
  },
};
</script>

<style scoped>
/* Sidebar slide-in animation */
.slide-enter-active,
.slide-leave-active {
  transition: transform 0.3s ease;
}
.slide-enter-from {
  transform: translateX(-100%);
}
.slide-leave-to {
  transform: translateX(-100%);
}
</style>
